"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.UserError = exports.ServerValidationError = exports.ServerError = exports.DatasetError = exports.DataBindingError = exports.CoreError = exports.AppError = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
class DataBindingError extends Error {
  static of(message, options, errorName) {
    return new this(message, options, errorName);
  }
  static withMessage(message) {
    return class extends this {
      constructor(options, errorName) {
        super(message, options, errorName);
      }
    };
  }
  static with({
    message: predefinedMessage,
    options: predefinedOptions
  }) {
    return class extends this {
      constructor(arg) {
        const message = predefinedMessage || arg instanceof String && arg;
        const options = {
          ...predefinedOptions,
          ...(arg instanceof Object ? arg : {})
        };
        super(message, options);
      }
    };
  }
  constructor(message, options, errorName = 'DataBindingError') {
    super(message, options);
    (0, _defineProperty2.default)(this, "options", void 0);
    (0, _defineProperty2.default)(this, "scope", void 0);
    (0, _defineProperty2.default)(this, "code", void 0);
    const {
      cause,
      ...rest
    } = options || {};
    this.name = errorName;
    this.options = rest;
    if (!this.cause) {
      this.cause = cause;
    }
  }
  toString() {
    return this.cause ? `${super.toString()}\nCaused by ${this.cause.toString()}` : super.toString();
  }
}
exports.DataBindingError = DataBindingError;
(0, _defineProperty2.default)(DataBindingError, "scopes", {
  USER_SCOPE: 'userCodeZone',
  APPLICATION_SCOPE: 'applicationCodeZone',
  SERVER_SCOPE: 'wixDataCodeZone',
  CORE_SCOPE: 'coreCodeZone'
});
class AppError extends DataBindingError {
  constructor(message, options) {
    super(message, options, 'AppError');
    this.scope = DataBindingError.scopes.APPLICATION_SCOPE;
  }
}
exports.AppError = AppError;
class CoreError extends DataBindingError {
  constructor(message, options) {
    super(message, options, 'CoreError');
    this.scope = DataBindingError.scopes.CORE_SCOPE;
  }
}
exports.CoreError = CoreError;
class UserError extends DataBindingError {
  constructor(message, options, errorName = 'UserError') {
    super(message, options, errorName);
    this.scope = DataBindingError.scopes.USER_SCOPE;
  }
}

//TODO: Do we really need it?
// It seems like there is no clear distinction between DatasetError and UserError
exports.UserError = UserError;
class DatasetError extends UserError {
  constructor(message, options) {
    const {
      code,
      ...rest
    } = options;
    super(message, rest, 'DatasetError');
    this.code = code;
  }
}
exports.DatasetError = DatasetError;
class ServerValidationError extends UserError {
  constructor(message, options) {
    super(message, options, 'ServerValidationError');
  }
}
exports.ServerValidationError = ServerValidationError;
(0, _defineProperty2.default)(ServerValidationError, "codes", ['WD_SITE_IN_TEMPLATE_MODE', 'WD_PERMISSION_DENIED', 'WD_COLLECTION_DELETED', 'WD_VALIDATION_FAILED']);
class ServerError extends DataBindingError {
  constructor(message, options) {
    const {
      code,
      ...rest
    } = options;
    super(message, rest, 'ServerError');
    this.scope = DataBindingError.scopes.SERVER_SCOPE;
    this.code = code;
  }
}
exports.ServerError = ServerError;
//# sourceMappingURL=errors.js.map